import React from "react";
import Item from "./components/Item";

class Experience extends React.Component<{}, {}> {
    render() {
        return (
            <div className="Experience py-lg-5" id="experience">
                <div className="row">
                    <h1>Experience</h1>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <Item
                            heading="Oracle"
                            duration="June 2021 - July 2021"
                            role="Intern"
                        >
                            <ul>
                                <li>
                                    Extended payload handling feature-set for Oracle Managed File Transfer.
                                </li>
                            </ul>
                        </Item>
                        <Item
                            heading="OttonomyIO"
                            duration="June 2020 - July 2020"
                            role="Autonomous Robotics and AI Intern"
                        >
                            <ul>
                                <li>
                                    Developed an efficient real-time semantic
                                    segmentation model for autonomous rovers.
                                </li>
                                <li>
                                    Fine-tuned models on Cityscapes and BDD
                                    datasets.
                                </li>
                            </ul>
                        </Item>
                        <Item
                            heading="Google Summer of Code, The GNU Project"
                            duration="May 2019 - August 2019"
                            role="Student Software Developer"
                        >
                            <ul>
                                <li>
                                    Increased Wget2’s code coverage for HTTP by
                                    25.00% and TLS by 18.50%.
                                </li>
                                <li>
                                    Designed OCSP and HTTP/2 response servers
                                    for the existing testsuite.
                                </li>
                            </ul>
                        </Item>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <Item
                            heading="IIRS, Indian Space Research Organization"
                            duration="May 2019 - July 2019"
                            role="Research Intern"
                        >
                            <ul>
                                <li>
                                    Developed a highly accurate Deep Learning
                                    solution for semantic segmentation of
                                    buildings in very-high-resolution images.
                                </li>
                                <li>
                                    Developed a thermal image processing tool
                                    for WebODM.
                                </li>
                            </ul>
                        </Item>
                        <Item
                            heading="Wiztute Pvt. Ltd."
                            duration="December 2018 - January 2019"
                            role="Backend Intern"
                        >
                            <ul>
                                <li>
                                    Designed, implemented, and deployed a pilot
                                    backend within 14 days.
                                </li>
                                <li>
                                    Created API end-points using Django REST
                                    Framework for payment gateway and
                                    video-conferencing module.
                                </li>
                            </ul>
                        </Item>
                    </div>
                </div>
            </div>
        );
    }
}

export default Experience;
